<template>
  <div id='bd-top'>
    <!-- v-popover:visitorcard -->
    <el-image class="avatar" style="width: 35px; height: 35px;" :src="userCurrentThread.avatar" :preview-src-list="[userCurrentThread.avatar]"/>
    <!-- <img class="avatar" width="35" height="35" :alt="userCurrentThread.nickname" :src="userCurrentThread.avatar"> -->
    <span class="nickname">
      {{ getThreadNickname(userCurrentThread) }}
      <span v-if="currentThreadUrl.url"><a :href="currentThreadUrl.url" target="_blank">网址:{{ formatUrlTitle() }}</a></span>
      <span v-if="currentThreadUrl.preUrl"><a :href="currentThreadUrl.preUrl" target="_blank">,来源网址</a></span>
      <el-tag v-if="userCurrentThread.closed" size="mini">{{ threadClosedTip }}</el-tag>
    </span>
    <!-- <div>{{ fromClient(userCurrentThread) }}</div> -->
    <span class="wrapper">
      <!-- TODO: 会话置顶、禁止/允许消息通知 -->
      <!-- TODO: 增加一键机器人接管 -->
      <!-- TODO: 宽度不够的情况下，按钮不能一行安排，有待优化处理 -->
      <el-link v-if="isTypeThread(userCurrentThread)" @click="showCrmDrawer()" type="success" size="mini" :disabled="disabled">{{ $t('crm') }}</el-link>
      <!-- TODO: showAuthority.debug &&  -->
      <el-link style="margin-left: 10px;" v-if="isTypeThread(userCurrentThread)" @click="addTicket()" type="warning" size="mini" :disabled="disabled">{{ $t('tickets') }}</el-link>
      <!-- <el-button v-if="showAuthority.debug" @click="showInviteChat()" type="warning" size="mini" :disabled="disabled">邀请</el-button> -->
      <!--  && !userCurrentThread.closed / || userCurrentThread.closed -->
      <el-link style="margin-left: 10px;" v-if="isTypeThread(userCurrentThread)" @click="showTransferChat()" type="success" size="mini" :disabled="disabled">{{ $t('transfer') }}</el-link>
      <!-- <el-button v-if="isTypeThread(userCurrentThread)" @click="showNoteDialog()" type="info" size="mini" :disabled="disabled">备注</el-button> -->
      <!-- 迁移到输入框上方 -->
      <!-- <el-button @click="showInviteRate()" type="warning" size="mini" icon="el-icon-star-off" :disabled="disabled">邀评</el-button> -->
      <el-link style="margin-left: 10px;" v-if="isTypeThread(userCurrentThread)" @click="showSummaryDrawer()" type="primary" size="mini" :disabled="disabled">{{ $t('summary') }}</el-link>
      <el-link style="margin-left: 10px;" v-if="isTypeThread(userCurrentThread) && !userCurrentThread.closed" @click="showCloseChat()" type="danger" size="mini" :disabled="disabled || userCurrentThread.closed">{{ $t('close') }}</el-link>
      <!-- <el-button v-if="isTypeThread(userCurrentThread)" @click="showDeleteThread()" type="danger" size="mini" :disabled="disabled">关闭</el-button> -->
      <!-- info -->
      <!-- <el-button v-if="isTypeContact(userCurrentThread)" @click="showContactInfoDrawer()" type="info" size="mini" icon="el-icon-user"></el-button> -->
      <!-- <el-button v-if="isTypeGroup(userCurrentThread)" @click="showGroupInfoDrawer()" type="info" size="mini" icon="el-icon-user"></el-button> -->
      <el-link style="margin-left: 10px;" v-if="isTypeTicketThread(userCurrentThread)" @click="doIgnore()" type="warning" size="mini" :disabled="ticketDisabled">{{ $t('doIgnore') }}</el-link>
      <el-link style="margin-left: 10px;" v-if="isTypeTicketThread(userCurrentThread)" @click="doDone()" type="danger" size="mini" :disabled="ticketDisabled">{{ $t('doFinish') }}</el-link>
    </span>
    <!-- <div style="float: left; font-size: 12px; margin-left: 5px;">
      <span v-if="currentThreadUrl.url"><a :href="currentThreadUrl.url" target="_blank">对话网址：{{ formatUrlTitle() }}</a></span>
      <span v-if="currentThreadUrl.preUrl"><a :href="currentThreadUrl.preUrl" target="_blank"> 来源网址</a></span>
    </div> -->
    <!-- 个人资料 -->
    <!-- <el-drawer
      :title="profileTip"
      :visible.sync="contactInfoDrawerVisible"
      :direction="drawerDirection"
      :before-close="handleDrawerClose"
      size="30%">
    </el-drawer> -->

    <!-- 群组资料 -->
    <!-- <el-drawer
      :title="groupProfileTip"
      :visible.sync="groupInfoDrawerVisible"
      :direction="drawerDirection"
      :before-close="handleDrawerClose"
      size="30%">
    </el-drawer> -->

    <!-- 会话小结 -->
    <!-- TODO: 会话添加标签 -->
    <el-drawer
      size="50%"
      :title="summaryTip"
      :visible.sync="summaryDrawerVisible"
      :direction="drawerDirection"
      :before-close="handleDrawerClose">
      <div class="demo-drawer__content">
        <el-form>
          <el-form-item :label="solvedTip" :label-width="formLabelWidth">
            <el-radio v-model="summary.solved" :label="true">{{ solvedTip }}</el-radio>
            <el-radio v-model="summary.solved" :label="false">{{ unsolvedTip }}</el-radio>
          </el-form-item>
          <el-form-item :label="contentTip" :label-width="formLabelWidth">
            <!-- <el-input style="margin-left:10px; margin-right:10px;"
              type="textarea"
              :rows="10"
              :placeholder="pleaseInputSummaryContentTip"
              v-model="summary.content">
            </el-input> -->
            <!-- TODO: 富文本 -->
            <tinymce v-model="summary.content"></tinymce>
          </el-form-item>
          <el-form-item :label="tagTip" :label-width="formLabelWidth">
            <el-checkbox-group v-model="summary.tags" size="mini" style="margin-left: 10px;">
              <el-checkbox v-for="tag in threadTags" :label="tag.name" :key="tag.tid" border></el-checkbox>
            </el-checkbox-group>
            <div v-if="threadTags.length === 0">{{ pleaseCreateTagFirstTip }}</div>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="summaryDrawerVisible = false" size="mini">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="createSummary" size="mini">{{ $t('ok') }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- CRM -->
    <el-drawer
      size="40%"
      :title="addToCrmTip"
      :visible.sync="addCrmDrawerVisible"
      :direction="drawerDirection"
      ref="drawer"
      :before-close="handleDrawerClose">
      <div class="demo-drawer__content">
        <el-form :model="crm">
          <el-form-item :label="nameTip" :label-width="formLabelWidth">
            <el-input v-model="crm.name" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item :label="mobileTip" :label-width="formLabelWidth">
            <el-input v-model="crm.mobile" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item :label="emailTip" :label-width="formLabelWidth">
            <el-input v-model="crm.email" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item :label="ageTip" :label-width="formLabelWidth">
            <el-input v-model="crm.age" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item :label="jobTip" :label-width="formLabelWidth">
            <el-input v-model="crm.job" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item :label="companyTip" :label-width="formLabelWidth">
            <el-input v-model="crm.company" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item :label="noteTip" :label-width="formLabelWidth">
            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="crm.description"></el-input>
          </el-form-item>
          <el-form-item :label="tagTip" :label-width="formLabelWidth">
            <el-checkbox-group v-model="tagNames" size="mini" style="margin-left: 10px;">
              <el-checkbox v-for="tag in userTags" :label="tag.name" :key="tag.tid"></el-checkbox>
            </el-checkbox-group>
            <div v-if="userTags.length === 0">{{ pleaseCreateTagFirstTip }}</div>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="addCrmDrawerVisible = false" size="mini">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="createCrm" size="mini">{{ $t('ok') }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 转接会话 -->
    <el-drawer
      :title="transferTip"
      :visible.sync="transferDrawerVisible"
      :direction="drawerDirection"
      :before-close="handleDrawerClose">
      <div class="demo-drawer__content">
        <el-radio-group v-model="transferContactUid">
          <el-radio v-for="contact in contactTransferTableData" :key="contact.uid" :label="contact.uid">{{ contact.realName }}</el-radio>
        </el-radio-group>
        <div v-if="contactTransferTableData.length === 0">
          {{ $t('noOtherAgentOnline') }}
        </div>
        <div class="demo-drawer__footer">
          <el-button @click="transferDrawerVisible = false" size="mini">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="doTransferChat" size="mini" :disabled="contactTransferTableData.length === 0">{{ $t('transfer') }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 标签 -->
    <el-dialog v-dialogDrag
      title="用户标签"
      :visible.sync="tagDialogVisible"
      width="30%">
      <el-checkbox-group v-model="tagNames" size="mini" style="margin-left: 10px;">
        <el-checkbox v-for="tag in userTags" :label="tag.name" :key="tag.tid"></el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tagDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="updateTag">{{ $t('ok') }}</el-button>
      </span>
    </el-dialog>

    <!-- 用户卡片 -->
    <el-popover
      ref="visitorcard"
      trigger="hover"
      placement="right-start"
      popper-class="no-padding"
      :visible-arrow="false"
    >
      <VisitorCard />
    </el-popover>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as https from '@/apis/http'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')
import VisitorCard from '@/components/dashboard/setting/VisitorCard'

export default {
  name: 'bd-top',
  components: {
    VisitorCard
  },
  data () {
    return {
      //
      noteContent: '',
      // 当前已经加入会话的客服username
      invitedContactUserids: [],
      drawerDirection: 'rtl',
      contactInfoDrawerVisible: false,
      groupInfoDrawerVisible: false,
      summaryDrawerVisible: false,
      addCrmDrawerVisible: false,
      transferDrawerVisible: false,
      // 标签
      tagDialogVisible: false,
      tagNames: [],
      //
      isCreateSummary: true,
      summary: {
        id: 0,
        sid: '',
        solved: false,
        content: '',
        tags: []
      },
      dialog: false,
      loading: false,
      //
      isCreateCrm: true,
      crm: {
        id: 0,
        cid: '',
        name: '',
        email: '',
        mobile: '',
        age: 0,
        job: '',
        company: '',
        description: '',
        tid: '',
        tags: []
      },
      transferContactUid: '',
      formLabelWidth: '100px',
      // 关闭会话tid
      closeThreadTid: '',
      isCloseFromAside: false,
    }
  },
  computed: {
    ...mapGetters([ 'disabled', 'userCurrentThread',
      'userCurrentContact', 'userCurrentGroup', 'userInfo', 'onlineAgents', 'showAuthority',
      'threadTags', 'userTags', 'userCurrentCustomer',
      'userCurrentTicket', 'ticketDisabled',
      'monitorDisabled', 'userCurrentMonitorThread', 'currentThreadUrl']),
    //
    threadClosedTip () {
      return this.$t('closed')
    },
    profileTip () {
      return this.$t('profile')
    },
    groupProfileTip () {
      return this.$t('groupProfile')
    },
    summaryTip () {
      return this.$t('summary')
    },
    addToCrmTip () {
      return this.$t('addToCrm')
    },
    transferTip () {
      return this.$t('transfer')
    },
    contentTip () {
      return this.$t('content')
    },
    solvedTip() {
      return this.$t('solved')
    },
    issolvedTip() {
      return this.$t('issolved')
    },
    unsolvedTip() {
      return this.$t('unsolved')
    },
    pleaseInputSummaryContentTip () {
      return this.$t('pleaseInputSummaryContent')
    },
    pleaseCreateTagFirstTip () {
      return this.$t('pleaseCreateTagFirst')
    },
    noAgentOnlineTip () {
      return this.$t('noAgentOnline')
    },
    //
    nameTip () {
      return this.$t('name')
    },
    mobileTip () {
      return this.$t('mobile')
    },
    emailTip () {
      return this.$t('email')
    },
    ageTip () {
      return this.$t('age')
    },
    jobTip () {
      return this.$t('job')
    },
    companyTip () {
      return this.$t('company')
    },
    noteTip () {
      return this.$t('note')
    },
    tagTip () {
      return this.$t('tag')
    },
    realNameTip () {
      return this.$t('realName')
    },
    actionTip () {
      return this.$t('action')
    },
    // 转接客服数据
    // contactTransferTableData () {
    //   // 非在线状态的客服不能转接
    //   var transferContact = []
    //   for (var i = this.onlineAgents.content.length - 1; i >= 0; i--) {
    //     let uid = this.onlineAgents.content[i].uid
    //     let robot = this.onlineAgents.content[i].robot
    //     // 过滤掉自己和机器人
    //     if (this.userInfo.uid === uid || robot) {
    //       continue
    //     }
    //     let realName = this.onlineAgents.content[i].realName
    //     let status = this.onlineAgents.content[i].acceptStatus
    //     let contact = { uid, realName, status }
    //     transferContact.push(contact)
    //   }
    //   return transferContact
    // },
    contactTransferTableData () {
      // 非在线状态的客服不能转接
      var transferContact = []
      for (var i = this.onlineAgents.length - 1; i >= 0; i--) {
        let uid = this.onlineAgents[i].uid
        let robot = this.onlineAgents[i].robot
        // 过滤掉自己和机器人
        if (this.userInfo.uid === uid || robot) {
          continue
        }
        let realName = this.onlineAgents[i].realName
        let status = this.onlineAgents[i].acceptStatus
        let contact = { uid, realName, status }
        transferContact.push(contact)
      }
      return transferContact
    },
    // 邀请客服数据
    contactInviteData () {
      // 非在线状态的客服不能邀请
      var inviteContact = []
      for (var i = this.onlineAgents.content.length - 1; i >= 0; i--) {
        let key = this.onlineAgents.content[i].uid
        let robot = this.onlineAgents.content[i].robot
        if (this.userInfo.uid === key || robot) {
          continue
        }
        let label = this.onlineAgents.content[i].realName
        let disabled = false
        let contact = { key, label, disabled }
        inviteContact.push(contact)
      }
      return inviteContact
    }
  },
  methods: {
    ...mapActions('mqtt', [ 'sendMessageProtobuf' ]),
    ...mapActions([ 'inviteRate', 'agentCloseThread', 'removeClosedThread', 'setNote', 'getOnlineAgents', 'updateCurrentThreadNickname',
      'updateCurrentCustomer', 'getUserTags', 'getThreadTags', 'claimTicket', 'ignoreTicket', 'doneTicket']),
    getThreadNickname(thread) {
      if (thread.topic.startsWith('filehelper')) {
        return this.$t('fileHelper')
      }
      return thread.nickname
    },
    formatUrlTitle() {
      var title = decodeURI(this.currentThreadUrl.title)
      if (title && title.length > 6) {
        return title.substring(0, 6)
      }
      return title
    },
    // 格式化会话来源客户端
    fromClient (thread) {
      if (thread === null || thread === undefined || thread.client === '') {
        return ''
      }
      let client = thread.client;
      if (client.startsWith("web_pc")) {
        client = "web";
      } else if (client.startsWith("web_h5")) {
        client = "h5";
      } else if (client.startsWith("web")) {
        client = "web/h5";
      } else if (client.startsWith("android")) {
        client = this.$t("android");
      } else if (client.startsWith("ios")) {
        client = this.$t("ios");
      } else if (client.startsWith("wechat_mp")) {
        client = this.$t("wechat_mp");
      } else if (client.startsWith("wechat_mini")) {
        client = this.$t("wechat_mini");
      } else if (client.startsWith("flutter_android")) {
        client = this.$t("flutter_android");
      } else if (client.startsWith("flutter_ios")) {
        client = this.$t("flutter_ios");
      } else if (client.startsWith("flutter_web")) {
        client = this.$t("flutter_web");
      }
      return "[" + client + "]";
    },
    //
    isTypeThread (thread) {
      return thread.type === constants.THREAD_TYPE_WORKGROUP ||
        thread.type === constants.THREAD_TYPE_APPOINTED ||
        thread.type === constants.THREAD_TYPE_ROBOT
    },
    isTypeTicketThread (thread) {
      return thread.type === constants.THREAD_TYPE_TICKET_WORKGROUP ||
        thread.type === constants.THREAD_TYPE_TICKET_APPOINTED
    },
    isTypeContact (thread) {
      return thread.type === constants.THREAD_TYPE_CONTACT
    },
    isTypeGroup (thread) {
      return thread.type === constants.THREAD_TYPE_GROUP
    },
    // 转接会话
    showTransferChat () {
      this.transferDrawerVisible = true
      //
      // let payload = { page: 0, size: 100 }
      // this.getOnlineAgents(payload)
      this.getOnlineAgents()
    },
    isTransferButtonDisabled (status) {
      return false
    },
    // doTransferChat (index, row) {
    doTransferChat () {
      // console.log('do transfer:', this.transferContactUid)
      if (this.transferContactUid !== '') {
        let transferContactNickname = ''
        for (let i = 0; i < this.contactTransferTableData.length; i++) {
          const contact = this.contactTransferTableData[i]
          if (contact.uid == this.transferContactUid) {
            transferContactNickname = contact.nickname
          }
        }
        // TODO: 自定义附言内容
        let payload = {
          type: constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER,
          content: { topic: this.transferContactUid, content: transferContactNickname },
          thread: this.userCurrentThread
        }
        this.sendMessageProtobuf(payload)
        this.transferDrawerVisible = false
      } else {
        // console.log('uid is empty')
        this.$message.warning(this.$t('noContactSelected'))
      }
    },
    // 邀请评价
    // TODO: 收到访客评价之后，禁止重复邀请
    showInviteRate () {
      this.inviteRate(this.userCurrentThread.tid)
    },
    showCloseChat () {
      this.closeThreadTid = this.userCurrentThread.tid
      this.isCloseFromAside = false
      // 已经关闭
      if (this.userCurrentThread.closed) {
        this.removeClosedThread(this.closeThreadTid)
        return
      }
      this.shouldCloseThread()
    },
    shouldCloseThread () {
      // 弹窗询问
      this.$confirm(this.$t('wantToCloseThread'), this.$t('tip'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        // TODO: 首先判断是否是邀请加入的会话，如果是，需要调用退出会话接口，否则调用关闭会话接口
        // 关闭会话
        this.agentCloseThread(this.closeThreadTid)
      }).catch(() => {
        //
      })
    },
    showDeleteThread () {
      this.$confirm(this.$t('wantToCloseThread'), this.$t('tip'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        //
      }).catch(() => {
      })
    },
    showContactInfoDrawer () {
      this.contactInfoDrawerVisible = true
    },
    showGroupInfoDrawer () {
      this.groupInfoDrawerVisible = true
    },
    addTicket () {
      // console.log('add ticket')
      bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER)
    },
    showSummaryDrawer () {
      // console.log('add summary')
      this.getThreadTags()
      this.summary = {
        id: 0,
        sid: '',
        solved: true,
        content: '',
        tags: []
      }
      this.summaryDrawerVisible = true
      https.getSummary(this.userCurrentThread.tid, response => {
        // console.log('get summary success:', response)
        if (response.status_code === 200) {
          this.isCreateSummary = false
          // this.summary = response.data
          this.summary.id = response.data.id
          this.summary.sid = response.data.sid
          this.summary.solved = response.data.solved
          this.summary.content = response.data.content
          //
          let tags = []
          for (let i = 0; i < response.data.tags.length; i++) {
            const element = response.data.tags[i]
            tags.push(element.name)
          }
          this.summary.tags = tags
        } else {
          this.isCreateSummary = true
        }
      }, error => {
        console.log('get summary error', error)
        this.$message.error(error)
      })
    },
    createSummary () {
      console.log('create summary', this.summary)
      //
      if (this.isCreateSummary) {
        https.createSummary(this.userCurrentThread.tid, this.summary, response => {
          // console.log('create summary success:', response)
          this.$message({
            showClose: true,
            message: response.message,
            type: 'success'
          })
          this.summaryDrawerVisible = false
        }, error => {
          console.log('create summary error:', error)
          this.$message.error(error)
        })
      } else {
        https.updateSummary(this.summary, response => {
          // console.log('update summary success:', response)
          this.$message({
            showClose: true,
            message: response.message,
            type: 'success'
          })
          this.summaryDrawerVisible = false
        }, error => {
          console.log('create summary error:', error)
          this.$message.error(error)
        })
      }
    },
    initCrm() {
      this.getUserTags()
      this.crm = {
        id: 0,
        cid: '',
        name: this.userCurrentThread.nickname,
        email: '',
        mobile: '',
        age: 0,
        job: '',
        company: '',
        description: '',
        tid: '',
        tags: []
      }
      https.getCustomer(this.userCurrentThread.tid, response => {
        // console.log('get customer success:', response)
        if (response.status_code === 200) {
          this.isCreateCrm = false
          this.crm = response.data
          //
          this.tagNames = []
          for (let i = 0; i < response.data.tags.length; i++) {
            const element = response.data.tags[i]
            this.tagNames.push(element.name)
          }
          // this.crm.tags = tags
        } else {
          this.isCreateCrm = true
        }
      }, error => {
        console.log('get customer error:', error)
        this.$message.error(error)
      })
    },
    showCrmDrawer () {
      console.log('add crm tid: ', this.userCurrentThread.tid)
      this.initCrm()
      this.addCrmDrawerVisible = true
      // this.tagNames = [];
      // if (this.userCurrentCustomer.tags != null) {
      //   for (let i = 0; i < this.userCurrentCustomer.tags.length; i++) {
      //     const tag = this.userCurrentCustomer.tags[i];
      //     this.tagNames.push(tag.name);
      //   }
      // }
    },
    createCrm () {
      this.crm.tid = this.userCurrentThread.tid
      this.crm.tags = this.tagNames;
      console.log('crm info: ', this.crm)
      // if (this.isCreateCrm) {
      https.createCustomer(this.crm, response => {
        console.log('create customer success 2:', response)
        if (response.status_code === 200) {
            this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success'
          })
          this.addCrmDrawerVisible = false
          // 
          let customer = response.data
          // 更新会话列表中访客昵称
          this.updateCurrentThreadNickname(customer.name);
          this.updateCurrentCustomer(customer);
        } else {
          this.$message.error(response.message)
        }
      }, error => {
        console.log('create customer error', error)
        this.$message.error(error)
      })
      // }
      // else {
      //   https.updateCustomer(this.crm, response => {
      //     // console.log('update customer success:', response)
      //     this.$message({
      //       showClose: true,
      //       message: response.message,
      //       type: 'success'
      //     })
      //     this.addCrmDrawerVisible = false
      //     // 
      //     let customer = response.data
      //     // 更新会话列表中访客昵称
      //     this.updateCurrentThreadNickname(customer.name);
      //     this.updateCurrentCustomer(customer);
      //   }, error => {
      //     console.log('update customer error', error)
      //     this.$message.error(error)
      //   })
      // }
    },
    updateTag() {
      this.tagDialogVisible = false
      this.crm.tid = this.userCurrentThread.tid
      this.crm.tags = this.tagNames;
      console.log('crm info: ', this.crm)
      https.createCustomer(this.crm, response => {
        console.log('create tag success 2:', response)
        if (response.status_code === 200) {
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success'
          })
          // 
          let customer = response.data
          this.updateCurrentCustomer(customer);
        } else {
          this.$message.error(response.message)
        }
      }, error => {
        console.log('create tag error', error)
        this.$message.error(error)
      })
    },
    handleClose (done) {
      done()
    },
    handleDrawerClose (done) {
      done()
    },
    doIgnore () {
      this.$confirm(this.$t('ticketIgnoreAsure'), this.$t('tip'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        //
        this.ignoreTicket(this.userCurrentTicket.tid)
      }).catch(() => {
        // this.$message.error(error)
      })
    },
    doDone () {
      this.$confirm(this.$t('ticketFinishAsure'), this.$t('tip'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        //
        this.doneTicket(this.userCurrentTicket.tid)
      }).catch(() => {
        // this.$message.error(error)
      })
    }
  },
  mounted () {
    //
    let app = this
    bus.$on(constants.EVENT_BUS_THREAD_AGENT_CLOSE, tid => {
      // console.log('close:' + tid)
      app.closeThreadTid = tid
      app.isCloseFromAside = true
      app.shouldCloseThread()
    })
    // 显示转接会话drawer
    bus.$on(constants.EVENT_BUS_SHOW_TRANSFER_DRAWER, message => {
      app.showTransferChat()
    })
    // 显示小结drawer
    bus.$on(constants.EVENT_BUS_SHOW_SUMMARY_DRAWER, message => {
      app.showSummaryDrawer()
    })
    // 显示结束会话dialog
    bus.$on(constants.EVENT_BUS_SHOW_CLOSE_CHAT, message => {
      app.showCloseChat()
    })
    // 显示crm drawer
    bus.$on(constants.EVENT_BUS_SHOW_CRM_DRAWER, message => {
      app.showCrmDrawer()
    })
    // 显示标签dialog
    bus.$on(constants.EVENT_BUS_SHOW_TAG_DIALOG, message => {
      // console.log('tag dialog')
      app.initCrm()
      app.tagDialogVisible = true
      app.tagNames = [];
      if (app.userCurrentCustomer.tags != null) {
        for (let i = 0; i < app.userCurrentCustomer.tags.length; i++) {
          const tag = app.userCurrentCustomer.tags[i];
          app.tagNames.push(tag.name);
        }
      }
    })
  },
  beforeDestroy () {
    bus.$off(constants.EVENT_BUS_SHOW_CRM_DRAWER)
    bus.$off(constants.EVENT_BUS_BLOCK_USER)
  }
}
</script>

<style scoped>
#bd-top {
  width: 100%;
  height: 50px;
  border-bottom:solid 0.1px #dddddd;
}
#bd-top .avatar {
  margin-top: 7px;
  margin-left: 10px;
  float: left;
}
#bd-top .nickname {
  max-width: 350px;
  margin-left: 5px;
  margin-top: 12px;
  float: left;
  font-size: 12px;
}
#bd-top .wrapper {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
  height: 40px;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px;
  overflow-y: scroll;
  text-align: left;
}
.demo-drawer__footer {
  position: absolute;
  bottom: 5px;
}
</style>
